/* 商品一覧のページ送り・絞り込みでブラウザの「戻る」が効かない問題の修正。
   テーマ本体が history.replaceState を使っており履歴が積まれないため、
   その直後に正しい履歴を積み直し、戻る／進むで再描画する。
   ※ theme.js より後に読み込むこと */
(function () {
  var lastUrl = location.href;
  var restoring = false;

  function currentSectionId() {
    var host =
      document.querySelector('[id^="shopify-section-"] .collection') ||
      document.querySelector('[id^="shopify-section-"] facets-form') ||
      document.querySelector('[id^="shopify-section-"] .pagination');
    var section = host && host.closest('[id^="shopify-section-"]');
    return section ? section.id.replace("shopify-section-", "") : null;
  }

  // テーマ本体のハンドラのあとに実行される
  document.addEventListener("facet:update", function () {
    if (restoring) {
      restoring = false;
      lastUrl = location.href;
      return;
    }
    var newUrl = location.href;
    if (newUrl === lastUrl) return;

    // 本体が上書きした分を巻き戻してから、新しい履歴として積む
    history.replaceState(history.state, "", lastUrl);
    history.pushState({ facetHistory: true }, "", newUrl);
    lastUrl = newUrl;
  });

  // 戻る／進むが押されたら、その URL の内容を描画し直す
  window.addEventListener("popstate", function () {
    var sectionId = currentSectionId();
    if (!sectionId) return;
    lastUrl = location.href;
    var url = new URL(location.href);
    url.searchParams.set("section_id", sectionId);
    restoring = true;
    document.dispatchEvent(
      new CustomEvent("facet:update", { detail: { url: url } })
    );
  });
})();